module.exports = __webpack_public_path__ + "img/electron_beam.08f7c2dd.png";